<template>
  <div>
    <el-dialog
      class="top-draft-dialog"
      width="1000px"
      title="操作日志"
      :visible.sync="visible"
      @close="$emit('update:show', false)"
      :show="show"
    >
      <div style="max-height: 80vh; overflow: auto">
        <div>
          <div>
            <span>
              <el-input
                placeholder="请输入 姓名 操作"
                style="width: 225px; margin: 10px 30px"
                v-model.trim="addPageParams.content"
                size="small"
              ></el-input>
              <el-button round @click="addSearch" type="primary" size="small"
                >搜索</el-button
              >
              <el-button round size="small" @click="addResetParams"
                >重置</el-button
              >
            </span>
          </div>
        </div>
        <div class="item" style="width: 95%; margin: 10px auto">
          <t-table
            maxHeight="calc(80vh - 160px)"
            rowKey="id"
            :columns="addCircleTitle"
            :data="addCircleList"
          >
            <template #resType="{ row }">
              {{ contentType(row.resType) }}
            </template>
            <template #action="{ row }">
              {{ row.action }}
              <span
                style="cursor: pointer"
                @click="openContent(row.content)"
                v-if="
                  row.action == '编辑内容' ||
                    row.action == '编辑信息' ||
                    row.action == '新增'
                "
                >>>
              </span>
            </template>
          </t-table>
          <pagination
            ref="addPage"
            @pageCallback="addPageCallback"
          ></pagination>
        </div>
      </div>
      <!-- <div
        style="display: flex;
    justify-content: flex-end;margin: 15px 20px 15px 0;"
      >
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="checkAddCri">确 定</el-button>
      </div> -->
    </el-dialog>
    <el-dialog
      title="操作记录"
      :visible.sync="dialogVisible"
      class="log-record"
      width="1200px"
    >
      <div style="height: 70vh; overflow: hidden" class="loglist">
        <div
          style="width: 100%; height: 50vh; display: inline-block; padding: 0"
        >
          <div
            style="
              margin-bottom: 10px;
              margin-top: 10px;
              width: 100%;
              padding-right: 10px;
            "
            class="flex-align-center"
          >
            <span style="width: 283px; font-weight: bold; font-size: 16px"
              >参数</span
            ><span
              style="
                width: 390px;
                margin-left: 30px;
                font-weight: bold;
                font-size: 16px;
              "
              >修改前</span
            ><span
              style="
                width: 390px;
                margin-left: 30px;
                font-weight: bold;
                font-size: 16px;
              "
              >修改后</span
            >
          </div>
          <div class="log-content-table">
            <div v-for="(val, key) in before" :key="key">
              <div class="border-bottom-log">
                <span style="width: 283px; overflow: auto">{{ key }}</span>
                <span
                  v-if="getType(val) != 'Object'"
                  :style="{
                    width: '390px',
                    'margin-left': '30px',
                    'min-height': '10px',
                    color:
                      after[key] === '' && before[key] != '' ? 'red' : 'black',
                  }"
                  >{{ before[key] }}</span
                ><span
                  v-if="getType(val) != 'Object'"
                  :style="{
                    width: '390px',
                    'min-height': '10px',
                    'margin-left': '30px',
                    color: before[key] !== after[key] ? 'red' : 'black',
                  }"
                  >{{ after[key] }}</span
                >
              </div>
              <div v-if="getType(val) == 'Object'">
                <div v-for="(val1, key1) in val" :key="key1">
                  <div class="border-bottom-log">
                    <span
                      :style="{
                        width: '283px',
                        overflow: 'auto',
                        'padding-left': '20px',
                      }"
                      >{{ key1 }}</span
                    >
                    <span
                      v-if="getType(val1) != 'Object'"
                      :style="{
                        width: '390px',
                        'margin-left': '30px',
                        'min-height': '10px',
                        color:
                          after[key][key1] === '' && before[key][key1] != ''
                            ? 'red'
                            : 'black',
                      }"
                      >{{ before[key][key1] }}</span
                    ><span
                      v-if="getType(val1) != 'Object'"
                      :style="{
                        width: '390px',
                        'min-height': '10px',
                        'margin-left': '30px',
                        color:
                          before[key][key1] !== after[key][key1]
                            ? 'red'
                            : 'black',
                      }"
                      >{{ after[key][key1] }}</span
                    >
                  </div>
                  <div v-if="getType(val1) == 'Object'">
                    <div v-for="(val2, key2) in val1" :key="key2">
                      <div class="border-bottom-log">
                        <span
                          :style="{
                            width: '283px',
                            overflow: 'auto',
                            'padding-left': '40px',
                          }"
                          >{{ key2 }}</span
                        >
                        <span
                          v-if="getType(val2) != 'Object'"
                          :style="{
                            width: '390px',
                            'margin-left': '30px',
                            'min-height': '10px',
                            color:
                              after[key][key1][key2] === '' &&
                              before[key][key1][key2] != ''
                                ? 'red'
                                : 'black',
                          }"
                          >{{ before[key][key1][key2] }}</span
                        ><span
                          v-if="getType(val2) != 'Object'"
                          :style="{
                            width: '390px',
                            'min-height': '10px',
                            'margin-left': '30px',
                            color:
                              before[key][key1][key2] !== after[key][key1][key2]
                                ? 'red'
                                : 'black',
                          }"
                          >{{ after[key][key1][key2] }}</span
                        >
                      </div>
                      <div v-if="getType(val2) == 'Object'">
                        <div v-for="(val3, key3) in val2" :key="key3">
                          <div class="border-bottom-log">
                            <span
                              :style="{
                                width: '283px',
                                overflow: 'auto',
                                'padding-left': '60px',
                              }"
                              >{{ key3 }}</span
                            >
                            <span
                              v-if="getType(val3) != 'Object'"
                              :style="{
                                width: '390px',
                                'margin-left': '30px',
                                'min-height': '10px',
                                color:
                                  after[key][key1][key2][key3] === '' &&
                                  before[key][key1][key2][key3] != ''
                                    ? 'red'
                                    : 'black',
                              }"
                              >{{ before[key][key1][key2][key3] }}</span
                            ><span
                              v-if="getType(val3) != 'Object'"
                              :style="{
                                width: '390px',
                                'min-height': '10px',
                                'margin-left': '30px',
                                color:
                                  before[key][key1][key2][key3] !==
                                  after[key][key1][key2][key3]
                                    ? 'red'
                                    : 'black',
                              }"
                              >{{ after[key][key1][key2][key3] }}</span
                            >
                          </div>
                          <div v-if="getType(val3) == 'Object'">
                            <div v-for="(val4, key4) in val3" :key="key4">
                              <div class="border-bottom-log">
                                <span
                                  :style="{
                                    width: '283px',
                                    overflow: 'auto',
                                    'padding-left': '80px',
                                  }"
                                  >{{ key4 }}</span
                                >
                                <span
                                  v-if="getType(val4) != 'Object'"
                                  :style="{
                                    width: '390px',
                                    'margin-left': '30px',
                                    'min-height': '10px',
                                    color:
                                      after[key][key1][key2][key3][key4] ==
                                        '' &&
                                      before[key][key1][key2][key3][key4] != ''
                                        ? 'red'
                                        : 'black',
                                  }"
                                  >{{
                                    before[key][key1][key2][key3][key4]
                                  }}</span
                                ><span
                                  v-if="getType(val4) != 'Object'"
                                  :style="{
                                    width: '390px',
                                    'min-height': '10px',
                                    'margin-left': '30px',
                                    color:
                                      before[key][key1][key2][key3][key4] !==
                                      after[key][key1][key2][key3][key4]
                                        ? 'red'
                                        : 'black',
                                  }"
                                  >{{
                                    after[key][key1][key2][key3][key4]
                                  }}</span
                                >
                              </div>
                              <div v-if="getType(val4) == 'Object'">
                                <div v-for="(val5, key5) in val4" :key="key5">
                                  <div class="border-bottom-log">
                                    <span
                                      :style="{
                                        width: '283px',
                                        overflow: 'auto',
                                        'padding-left': '100px',
                                      }"
                                      >{{ key5 }}</span
                                    >
                                    <span
                                      :style="{
                                        width: '390px',
                                        'margin-left': '30px',
                                        'min-height': '10px',
                                        color:
                                          after[key][key1][key2][key3][key4][
                                            key5
                                          ] == '' &&
                                          before[key][key1][key2][key3][key4][
                                            key5
                                          ] != ''
                                            ? 'red'
                                            : 'black',
                                      }"
                                      >{{
                                        before[key][key1][key2][key3][key4][
                                          key5
                                        ]
                                      }}</span
                                    ><span
                                      :style="{
                                        width: '390px',
                                        'min-height': '10px',
                                        'margin-left': '30px',
                                        color:
                                          after[key][key1][key2][key3][key4][
                                            key5
                                          ] != '' &&
                                          before[key][key1][key2][key3][key4][
                                            key5
                                          ] !==
                                            after[key][key1][key2][key3][key4][
                                              key5
                                            ]
                                            ? 'red'
                                            : 'black',
                                      }"
                                      >{{
                                        after[key][key1][key2][key3][key4][key5]
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 200px; display: inline-block"></div>
        <div style="width: 200px; display: inline-block"></div>
      </div>

      <span slot="footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "@/server/api/account";
import { getTypeName } from "@/util/fun.js";
import pagination from "@/components/pagination/pagination.vue";

export default {
  components: {
    pagination,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    resId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      addPageParams: {
        page: 1,
        pageSize: 30,
        resId: null,
        content: "",
      },
      dialogVisible: false,
      Operation: "",
      visible: this.show,
      addCircleList: [], //新建列表
      addCircleTitle: [
        { colKey: "id", title: "id", width: 80 },
        {
          colKey: "userName",
          title: "姓名",
          width: 130,
        },
        {
          colKey: "resType",
          title: "资源类型",
          width: 100,
        },
        { colKey: "action", title: "操作", width: 80 },
        { colKey: "createdAt", title: "创建时间", width: 120 },
      ],
      before: {
        // hula: "233",
        // haha: {
        //   yes: "true",
        //   test: {
        //     xixi: "",
        //     hah: {
        //       huhu: {
        //         wawa: {
        //           wuwu: "3",
        //         },
        //       },
        //       sasa: "12",
        //     },
        //   },
        // },
      },
      after: {
        // hula: "235",
        // haha: {
        //   yes: "false",
        //   test: {
        //     xixi: "huhu",
        //     hah: {
        //       huhu: {
        //         wawa: {
        //           wuwu: "4",
        //         },
        //       },
        //       sasa: "14",
        //     },
        //   },
        // },
      },
    };
  },

  watch: {
    show() {
      this.visible = this.show;
      if (this.visible) {
        this.addPageParams.resId = this.resId;
        this.getList();
      }
    },
  },
  methods: {
    getList() {
      console.log("日志搜索参数", this.addPageParams);
      system.syslogList(this.addPageParams).then((res) => {
        console.log("操作日志", res);
        this.addCircleList = res.data.items;
        let pages = {
          page: res.data.page, //第几页
          pageSize: res.data.pageSize, //每页多少条
          total: res.data.total, //全部有多少条数据
          totalPages: res.data.totalPages, //全部有几页
        };
        console.log(pages);
        this.$nextTick(() => {
  if (this.$refs.addPage) {
    this.$refs.addPage.setPages(pages);
  }
});
      });
    },
    contentType(str) {
      return getTypeName(str);
    },
    addPageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.addPageParams.page = obj.page;
        this.getList();
      }
    },
    addSearch() {
      console.log(this.addPageParams.content);
      this.addPageParams.page = 1;
      this.getList();
    },
    processObj(obj1, obj2) {
      let obj3 = {};
      let obj4 = {};
      let key = this.getKeys(obj1, obj2);
      obj3 = this.setObj(obj1, key);
      obj4 = this.setObj(obj2, key);
      console.log("before", obj3, "after", obj4);
      this.setproperty(obj3, obj4);
      console.log("before", obj3, "after", obj4);
      this.before1 = obj3;
    },
    getKeys(obj1, obj2) {
      let key1 = Object.keys(obj1);
      let key2 = Object.keys(obj2);
      if (key1.length < key2.length) {
        for (let a = 0; a < key2.length; a++) {
          let str = "";
          if (key1[a] != key2[a]) {
            if (key1[a] === undefined) {
              continue;
            }
            if (key2.indexOf(key1[a]) == -1) {
              str = key2[a];
              key2[a] = key1[a];
              key2.splice(a, 0, str);
            }
          }
        }
        return key2;
      } else {
        for (let a = 0; a < key1.length; a++) {
          let str = "";
          if (key2[a] != key1[a]) {
            if (key2[a] === undefined) {
              continue;
            }
            if (key1.indexOf(key2[a]) == -1) {
              str = key1[a];
              key1[a] = key2[a];
              key1.splice(a, 0, str);
            }
          }
        }
        return key1;
      }
    },
    setObj(obj, key) {
      let obj1 = {};
      key.forEach((item) => {
        obj1[item] = obj[item] !== undefined ? obj[item] : "";
      });
      return obj1;
    },
    setproperty(obj1, obj2) {
      let key = this.getKeys(obj1, obj2);
      key.forEach((item) => {
        let type1 = this.getType(obj1[item]);
        let type2 = this.getType(obj2[item]);
        if (type1 == "Object" || type2 == "Object") {
          if (type1 == "Object" && type2 != "Object") {
            obj2[item] = {};
          } else if (type1 != "Object" && type2 == "Object") {
            obj1[item] = {};
          }

          let key1 = this.getKeys(obj1[item], obj2[item]);
          console.log(
            "key1",
            key1,
            "obj1",
            this.another(obj1),
            "obj2",
            this.another(obj2)
          );
          if (key1.length == 0) {
            obj1[item] = obj2[item] = "{}";
          } else {
            obj1[item] = this.setObj(obj1[item], key1);
            obj2[item] = this.setObj(obj2[item], key1);
            this.setproperty(obj1[item], obj2[item]);
          }
        }
        if (type1 == "Array") {
          obj1[item] = JSON.stringify(obj1[item]);
        }
        if (type2 == "Array") {
          obj2[item] = JSON.stringify(obj2[item]);
        }
      });
      console.log("第一次检查完毕");
    },
    addResetParams() {
      this.addPageParams.page = 1;
      this.addPageParams.content = "";
      this.getList();
    },
    openContent(str) {
      let obj1 = {};
      let obj2 = {};
      if (str.substr(0, 6) != "before") {
        obj2 = JSON.parse(str);
      } else if (str.substr(0, 13) == "before:after:") {
        obj2 = JSON.parse(str.substr(13));
      } else {
        // console.log(str.substr(7, str.indexOf("}after:{") - 6));
        obj1 = JSON.parse(str.substr(7, str.indexOf("}after:{") - 6));
        obj2 = JSON.parse(str.substr(str.indexOf("}after:{") + 7));
      }
      this.Operation = str;
      let key = this.getKeys(obj1, obj2);
      let obj3, obj4;
      obj3 = this.setObj(obj1, key);
      obj4 = this.setObj(obj2, key);
      this.setproperty(obj3, obj4);
      this.before = obj3;
      this.after = obj4;
      this.dialogVisible = true;
    },
    getType(item) {
      let str = Object.prototype.toString.call(item);
      return str.substr(8, str.length - 9);
    },
  },
};
</script>

<style lang="scss" scoped>
// .log-record ::v-deep .el-dialog {
//   overflow-y: hidden;
//   display: flex;
//   flex-direction: column;
// }
.log-record ::v-deep .el-dialog__body {
  padding-top: 0px !important;
  padding-bottom: 10px !important;
}
// .log-record ::v-deep .el-dialog .el-dialog__header {
//   flex-shrink: 0;
// }
// .log-record ::v-deep .el-dialog .el-dialog__footer {
//   flex-shrink: 0;
// }

.log-content-table {
  height: calc(70vh - 44px);
  overflow: auto;
  padding: 0 10px 0 0;
}

.loglist span {
  display: inline-block;
  height: 100%;
}
.border-bottom-log {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-width: 0px 0px 1px 0px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.border-bottom-log:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
